import { type CountMilestoneType } from "../models/milestone"
import { toNumberFormat } from "./number"

export function getCountMilestoneCopy(
	milestone: { type: CountMilestoneType; threshold: number },
	platformName: string,
) {
	const count = toNumberFormat(milestone.threshold)
	switch (milestone.type) {
		case "members":
			return {
				value: count,
				label: "members",
				title: `${count} members`,
				caption: `${platformName} just reached ${count} members! 🎉`,
			}
		case "community-members":
			return {
				value: count,
				label: "community members",
				title: `${count} community members`,
				caption: `The ${platformName} community just reached ${count} members! 🎉`,
			}
		case "community-posts":
			return milestone.threshold === 1
				? {
						value: "1st",
						label: "community post",
						title: "First community post",
						caption: `The ${platformName} community is live and the first post is up! 🎉`,
					}
				: {
						value: count,
						label: "community posts",
						title: `${count} community posts`,
						caption: `The ${platformName} community just passed ${count} posts! 🎉`,
					}
	}
}
